import { Link } from 'react-router-dom';
import NewsletterForm from '@/components/base/NewsletterForm';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  return (
    <footer className="bg-accent-950 px-4 pb-8 pt-14 text-background-100 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-heading text-lg font-bold text-background-50">
                瓜
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                西瓜黑料
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              按时间线整理每一段瓜，把起始、后续、反转与结局排成一条完整的线，让你像追连续剧一样，一次看懂来龙去脉。
            </p>
            <p className="mt-5 text-sm text-background-200/80">
              线索投稿与合作：
              <a
                href="mailto:contact@xigua-heiliao.example.com"
                rel="nofollow"
                className="ml-1 text-accent-200 hover:text-accent-100"
              >
                contact@xigua-heiliao.example.com
              </a>
            </p>
          </div>

          <nav className="md:col-span-2" aria-label="内容分类">
            <h4 className="font-heading text-sm font-semibold text-background-50">内容分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/dramas?cat=${cat.id}`}
                    className="text-background-200/80 transition-colors hover:text-accent-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="md:col-span-2" aria-label="站点导航">
            <h4 className="font-heading text-sm font-semibold text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200/80 transition-colors hover:text-accent-200">
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/dramas"
                  className="text-background-200/80 transition-colors hover:text-accent-200"
                >
                  瓜田总览
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-background-200/80 transition-colors hover:text-accent-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-background-200/80 transition-colors hover:text-accent-200"
                >
                  常见问题
                </Link>
              </li>
            </ul>
          </nav>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-background-50">订阅瓜讯</h4>
            <p className="mb-4 mt-3 text-xs leading-relaxed text-background-200/70">
              重大反转与结局更新时，提醒你回来看一眼。
            </p>
            <NewsletterForm />
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-accent-800/70 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} 西瓜黑料 · 内容均为创作化整理，不指向任何真实个人或机构</p>
          <p>理性吃瓜 · 尊重事实 · 拒绝人身攻击</p>
        </div>
      </div>
    </footer>
  );
}